import { useState, useMemo } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import IArrowShortail from "assets/i-arrow-shortail.js";
import IMagnifier from "assets/i-magnifier.js";
import XIconSrc from "assets/cross.svg";

import { useGlobalCtx } from "contexts/GlobalContext";

const ModalPilihLokasi = ({
  options,
  onClose,
  isOpen,
  selectedValues = [],
  onSelect,
  ...props
}) => {
  const [tempSelectedValues, setTempSelectedValues] = useState(selectedValues);
  
  const { listAreaOnlyComplete } = useGlobalCtx();

  const [search, setSearch] = useState("");

  const dataArea = useMemo(
    () =>
      listAreaOnlyComplete?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      ) ?? [],
    [listAreaOnlyComplete, search]
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleSelect = (id) => {
    if (tempSelectedValues.includes(id)) {
      setTempSelectedValues(tempSelectedValues.filter((item) => item !== id));
    } else {
      setTempSelectedValues([...tempSelectedValues, id]);
    }
  };

  const handleConfirm = () => {
    onSelect(tempSelectedValues);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[426px] z-[43] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between items-center px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <Button
            text="Kembali"
            type="secondary"
            icon={IArrowShortail}
            iconColor="#252526"
            onClick={onClose}
          />

          <p className="text-[13px] font-inter-semibold">Pilih Lokasi</p>
        </div>

        <div className="flex flex-col gap-[12px] items-center px-4 py-2 border-y border-solid border-[#D8D8D9]">
          <div className="w-full h-[32px] p-2 flex justify-center items-center gap-1 rounded-[4px] border-[1px] border-solid border-[#252526]">
            <IMagnifier color="#252526" />
            <input
              className="h-[24px] w-full py-2 text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#808285]"
              placeholder="Cari area"
              value={search}
              onChange={handleSearch}
            />
          </div>
          {!!tempSelectedValues?.length && !!dataArea?.length && (
            <div className="flex flex-wrap gap-2 w-full">
              {dataArea
                ?.filter((item) => tempSelectedValues.includes(item.id))
                ?.map((item) => (
                  <div className="flex items-center justify-center h-6 pl-2 gap-2 pr-1 rounded-[2px] bg-[#E6E7E8] w-fit">
                    <p className="text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526]">
                      {item.name}
                    </p>
                    <div
                      onClick={() => handleSelect(item.id)}
                      className="w-[16px] h-[16px] flex items-center justify-center bg-white rounded-[2px] cursor-pointer"
                    >
                      <img
                        src={XIconSrc}
                        alt="Remove"
                        className="w-[12px] h-[12px]"
                      />
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="flex flex-col px-4 py-0.5 border-y border-solid border-[#D8D8D9] h-[332px] overflow-y-auto">
          {!!search &&
            !!dataArea?.length &&
            dataArea.map((item) => (
              <div
                onClick={() => handleSelect(item.id)}
                key={item.id}
                className="flex items-center gap-2 py-2 border-b border-dashed border-[#D8D8D9] last:border-b-0"
              >
                <input
                  type="checkbox"
                  checked={tempSelectedValues.includes(item.id)}
                />
                <p>{item.name}</p>
              </div>
            ))}
        </div>

        <div
          className={
            "flex items-center justify-end gap-4 px-4 py-2 border-t border-solid border-[#D8D8D9]"
          }
        >
          <Button
            disabled={!tempSelectedValues?.length}
            text="Gunakan Lokasi"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalPilihLokasi isOpen={isOpen} {...props} />;
};

export default Wrapper;
